import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconTecnologiaElectrohogarOn(props) {
    return (
        <svg
            width={247}
            height={246}
            viewBox="0 0 247 246"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={123.319} cy={123} r={117} fill="#000" />
            <path
            d="M165.002 45.61H81.294c-6.44 0-11.68 5.853-11.68 13.043v126.06c0 7.16 5.24 13.013 11.68 13.013h83.708c6.44 0 11.649-5.853 11.679-13.043V58.653c0-7.19-5.239-13.043-11.679-13.043zm7.692 139.073c0 4.727-3.435 8.586-7.682 8.586H81.304c-4.257 0-7.683-3.83-7.683-8.586V58.653c0-4.757 3.436-8.586 7.683-8.586h83.708c4.227 0 7.682 3.83 7.682 8.586v126.03z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={2}
            strokeMiterlimit={10}
            />
            <path
            d="M158.781 65.603H87.514c-3.426 0-6.2 3.12-6.2 6.92v98.25c0 3.829 2.794 6.92 6.2 6.92h71.267c3.436 0 6.201-3.121 6.201-6.92v-98.22c-.01-3.83-2.775-6.95-6.201-6.95zm2.204 105.17c0 1.366-.982 2.463-2.204 2.463H87.514c-1.222 0-2.204-1.097-2.204-2.463v-98.22c0-1.366.982-2.463 2.204-2.463h71.267c1.222 0 2.204 1.097 2.204 2.463v98.22z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={2}
            strokeMiterlimit={10}
            />
            <path
            d="M123.163 245.24C55.251 245.24 0 190.227 0 122.62 0 55.003 55.25 0 123.163 0c67.922 0 123.172 55.003 123.172 122.62 0 67.607-55.25 122.62-123.172 122.62zm0-238.39C59.057 6.85 6.881 58.782 6.881 122.61c0 63.838 52.176 115.76 116.282 115.76 64.125 0 116.301-51.932 116.301-115.76S187.288 6.85 123.163 6.85z"
            fill="#000"
            />
            <path
            d="M123.509 180.275c-3.035 0-5.509 2.414-5.509 5.375 0 2.962 2.474 5.375 5.509 5.375s5.509-2.413 5.509-5.375c0-2.961-2.444-5.375-5.509-5.375zM121.881 59.78c1.141 0 2.073-1.038 2.053-2.314-.03-1.276-.932-2.313-2.074-2.284-1.141 0-2.073 1.038-2.073 2.314.05 1.236.952 2.283 2.094 2.283z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeMiterlimit={10}
            />
            <path
            d="M183.776 38.63c-1.162-10.63 6.581-20.173 17.238-21.33 10.678-1.156 20.253 6.522 21.415 17.152 1.162 10.61-6.54 20.172-17.218 21.319-10.658 1.157-20.273-6.532-21.435-17.141z"
            fill="#000"
            />
            <path
            d="M192.701 37.663c-.632-5.734 3.515-10.85 9.285-11.478 5.769-.628 10.908 3.49 11.529 9.224.621 5.714-3.506 10.85-9.275 11.477-5.76.628-10.918-3.51-11.539-9.223z"
            fill="#FFDD00"
            />
        </svg>
    )
}

export default SvgIconTecnologiaElectrohogarOn;